export default __webpack_public_path__ + "static/media/bg_gelb.4ba61f9c.png";